import { Box, useColorMode } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import bgAdmin from '../Assests/Img/admin-background.png';

const EditLayout = () => {
  const { colorMode } = useColorMode();
  return (
    <Box>
      <Box
        minH="40vh"
        w="100%"
        position="absolute"
        bgImage={colorMode === 'light' ? bgAdmin : 'none'}
        bg={colorMode === 'light' ? bgAdmin : 'navy.900'}
        bgSize="cover"
        top="0"
      />
      <Outlet />
    </Box>
  );
};
export default EditLayout;
